import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
// import TableChartIcon from "@mui/icons-material/TableChart";
import EmployeeReviewGraph from "./EmployeeReviewGraph";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { setCurrentPageTitle } from "../../../../../store/slices/pageSlice";

const EmployeeReview = () => {
 
  const dispatch = useDispatch();
  
    useEffect(()=>{
       dispatch(setCurrentPageTitle("Employee Review")) 
    },[dispatch])

            
  const popupRef = useRef(null);
  const { projects } = useSelector((state) => state.projects);

  useEffect(() => {
    dispatch(fetchAllProjects());
  }, [dispatch]);

  const [showLogout, setshowlogout] = useState(false);
  // const [employeeTab, setEmployeeTab] = useState("graph");

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);



  const groupedArray = [];

  projects.forEach((project) => {
    const person = project.ConfirmedAssignedperson?.[0]; // assuming 1 person per project

    if (!person) return; // skip if no assigned person

    const workEntries = project.WorkEntries || [];

    // Find if person already added
    const existing = groupedArray.find(
      (item) => item.AssignedPerson?.email === person.email
    );

    if (existing) {
      existing.tasks.push(...workEntries); // merge tasks
    } else {
      groupedArray.push({
        AssignedPerson: person,
        tasks: [...workEntries], // copy to avoid mutation
      });
    }
  });

  return (
    <div className="  pb-6 w-full mt-5 rounded-md">
      <div className="relative bg-white">
        <div className="bg-white px-2  flex justify-between align-middle items-center rounded-md">
          <h1 className="text-xl font-semibold"> Employee Review</h1>

          {/* <div className="flex gap-4 align-middle items-center">
            <div className="bg-white p-2 rounded-md shadow-lg">
              {employeeTab === "graph" && (
                <span title="Graph">
                  <SignalCellularAltIcon
                    className="cursor-pointer"
                    onClick={() => setEmployeeTab("table")}
                    fontSize="3rem"
                  />
                </span>
              )}
              {employeeTab === "table" && (
                <span title="Table">
                  <TableChartIcon
                    className="cursor-pointer"
                    onClick={() => setEmployeeTab("graph")}
                    fontSize="3rem"
                  />
                </span>
              )}
            </div>
            
          </div> */}
        </div>

        <hr />

        {/* {employeeTab === "graph" ? ( */}
          <div className="w-full">
            <div className="overflow-x-auto max-w-full max-h-[20rem] overflow-y-auto">
              <div className="grid grid-cols-7 bg-black text-white text-xs font-medium capitalize tracking-wider border-b text-center">
                {/* Sr.No Header */}
                <div className="px-3 bg-gray-700 py-3 border row-span-2 flex items-center justify-center capitalize">
                  Sr.No
                </div>
                <div className="px-3 bg-[#164e63] py-3 border row-span-2 flex items-center justify-center capitalize">
                  Employees
                </div>
                <div className="bg-orange-500 px-3 py-3 border row-span-2 flex items-center justify-center capitalize">
                  Role
                </div>
                <div className="bg-orange-500 col-span-2 px-3 py-2 border capitalize">
                  Approved Hours
                </div>
                <div className="px-3 py-3 bg-orange-500 border row-span-2 flex items-center justify-center capitalize">
                  Task Completed
                </div>
                <div className="px-3 py-3 bg-green-500 border row-span-2 flex items-center justify-center capitalize">
                  Productivity Score
                </div>
                <div className="bg-orange-500 px-3 py-2 border">Week</div>
                <div className="bg-orange-500 px-3 py-2 border">Month</div>
              </div>

              {groupedArray.map((group, index) => {
                const completedCount = group.tasks.filter(
                  (task) => task.taskStatus === "completed"
                ).length;
                const totalCount = group.tasks.length;
                const totalHoursAssigned = group.tasks.reduce(
                  (sum, task) => sum + (task.hoursassigned || 0),
                  0
                );
                const totalHoursSpent = group.tasks.reduce(
                  (sum, task) => sum + (task.hoursspent || 0),
                  0
                );

                const completionPercentageHours =
                  totalCount === 0 || totalHoursAssigned === 0
                    ? 0
                    : (
                        (completedCount / totalCount) *
                        (totalHoursSpent / totalHoursAssigned) *
                        100
                      ).toFixed(2);

                let weeks = "0";
                let months = "0";

                const totalDurationInMs = group.tasks.reduce((sum, task) => {
                  // Skip task if startdate or enddate is missing or invalid
                  if (!task.startdate || !task.enddate) return sum;

                  const start = new Date(task.startdate);
                  const end = new Date(task.enddate);

                  if (isNaN(start.getTime()) || isNaN(end.getTime()))
                    return sum;

                  // Only add duration if dates are valid
                  return sum + (end - start);
                }, 0);


                if (totalDurationInMs > 0) {
                  const totalHours = totalDurationInMs / (1000 * 60 * 60);
                  weeks = (totalHours / 40).toFixed(2); // Assuming 40 hours/week
                  months = (totalHours / 160).toFixed(2); // Assuming 160 hours/month
                }

                return (
                  <div key={index} className="flex border-b">
                    {/* Sr.No cell */}
                    <div className="flex-1 px-3 py-2 text-center border">
                      {index + 1}
                    </div>

                    <div className="flex-1 px-3 py-2 text-center border">
                      {group.AssignedPerson.name}
                    </div>
                    <div className="flex-1 px-3 py-2 text-center border">
                      Operation
                    </div>
                    <div className="flex-1 px-3 py-2 text-center border">
                      {weeks}
                    </div>
                    <div className="flex-1 px-3 py-2 text-center border">
                      {months}
                    </div>
                    <div className="flex-1 px-3 py-2 text-center border">
                      {completedCount}/{totalCount}
                    </div>
                    <div className="flex-1 px-3 py-2 text-center border">
                      {completionPercentageHours > 100 ? 100 : completionPercentageHours}%
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        {/* ) : (
          <EmployeeReviewGraph />
        )} */}

      </div>
                <EmployeeReviewGraph />

    </div>
  );
};

export default EmployeeReview;
